import Flickity from 'flickity';
import { getRTL } from './_utils';

const baseClass = 'HoverCardList';
const mobileCarouselClass = `${baseClass}-MobileCarousel`;

const selectors = {
	mobileCarouselContainer: `.${mobileCarouselClass}--container`,
	mobileCarouselList: `.${mobileCarouselClass}--list`,
	card: `.${baseClass}-GenericCard`,
};

const initMobileCarousel = $container => {
	const options = {
		cellAlign: 'center',
		pageDots: false,
		prevNextButtons: false,
		rightToLeft: getRTL(),
		wrapAround: false,
		selectedAttraction: 0.05,
		friction: 0.8,
		draggable: true,
		adaptiveHeight: false,
		resize: true,
		percentPosition: true,
		imagesLoaded: true,
		contain: true,
	};
	const $list = $container.children(selectors.mobileCarouselList);
	const $carousel = $list.get(0);

	$container.addClass(`${baseClass}--flickity`);
	const flickity = new Flickity($carousel, options);
	$carousel.removeAttribute('tabIndex');

	return flickity;
};

export default function initHoverCardListCarousels() {
	$(selectors.mobileCarouselContainer).each((i, mobileCarouselContainer) => {
		const $mobileCarouselContainer = $(mobileCarouselContainer);
		initMobileCarousel($mobileCarouselContainer);
	});
}
